// src/services/auth_api.js
import { apiClient } from "./api_client";
import swal from "./swal";

const authApi = {
  /* signups disabled
    signUp(userData) {
        // const dummyResponse = {
        //     data: {
        //         token: 'dummySignUpToken123',
        //         username: userData.username,
        //         password: userData.password,
        //         firstname: 'John',
        //         lastname: 'Doe',
        //         roles: {
        //             user: true,
        //             peermentor: true,
        //             admin: true,
        //         }
        //     }
        // };
        // return dummyResponse;

        //return apiClient.post('/signup', userData);
        // use below code when api becomes available
        
        return apiClient.post('/auth/signup', userData).then(response => {
            // Assuming the token is in response.data.token
            // const token = response.data.token;
            // if (token) {
            //     return response.data;
            // } else {
            //     throw new Error('signup failed');
            // }

            const message = response.data.message;

            if (message === 'User successfully signed up') {
                return message;
            } else if (message === 'Email already registered') {
              swal.fire({ icon: "error", text: "Email already registered!" });
                throw message;
            } else {
              swal.fire({ icon: "error", text: "Something went wrong." });
                throw message;
            }

        });
        
    },
    */
  login(credentials, force) {
    // when api becomes available, use this code:
    const params = new URLSearchParams();
    params.append("username", credentials.username);
    params.append("password", credentials.password);
    const url = force ? "/auth/login?force=true" : "/auth/login";

    return apiClient
      .post(url, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        // Assuming the token is in response.data.token
        const message = response.data.message;
        if (message === "no_email") {
          swal.fire({
            icon: "error",
            text: `No email: ${credentials.username}`,
          });
          return message;
        } else if (message === "wrong_password") {
          swal.fire({ icon: "error", text: "Wrong password" });
          return message;
        } else if (message === "not_active") {
          swal.fire({ icon: "warning", text: "This account is not activated" });
          return message;
        } else if (message === "locked") {
          swal.fire({ icon: "warning", text: "This account is locked" });
          return message;
        } else if (message === "not_verified") {
          swal.fire({ icon: "warning", text: "Please verify the email first" });
          return message;
        } else {
          const {
            access_token,
            refresh_token,
            firstname,
            lastname,
            roles,
            group_name,
            send_sms,
            send_email,
            enable_session_manipulation,
            profile_photo,
            phone_number,
          } = response.data;
          sessionStorage.setItem("authToken", access_token);
          sessionStorage.setItem("refreshToken", refresh_token);
          return {
            access_token,
            refresh_token,
            firstname,
            lastname,
            roles,
            group_name,
            send_sms,
            send_email,
            enable_session_manipulation,
            profile_photo,
            phone_number,
          };
        }
      });
  },
  logout() {
    return apiClient.post("/auth/logout", null, {}).then((response) => {
      const message = response.data.message;
      console.log(`${message}`);
      return message;
    });
  },

  /**
   * Request password reset - sends verification code to email
   * @param {string} email - User's email address
   * @returns {Promise<object>} Response with success status
   */
  requestPasswordReset: async (email) => {
    try {
      const response = await apiClient.post("/auth/request-password-reset", {
        email,
      });
      return response.data;
    } catch (error) {
      console.error("Request password reset error:", error);

      // STUB: Return dummy success for testing
      return {
        success: false,
        message: "Verification code failed to send to your email",
      };
    }
  },

  /**
   * Verify reset code
   * @param {string} email - User's email address
   * @param {string} code - 6-digit verification code
   * @returns {Promise<object>} Response with verification token
   */
  verifyResetCode: async (email, code) => {
    try {
      const response = await apiClient.post("/auth/verify-reset-code", {
        email,
        code,
      });
      return response.data;
    } catch (error) {
      console.error("Verify reset code error:", error);

      // STUB: Return dummy success if code is "123456"
      /*
      if (code === "123456") {
        return {
          success: true,
          token: "dummy-verification-token-12345",
          message: "Code verified successfully",
        };
      } else {
        */
      return {
        success: false,
        message: "Invalid verification code.", // use 123456 for testing
      };
      //}
    }
  },

  /**
   * Reset password with verification token
   * @param {string} email - User's email address
   * @param {string} token - Verification token from code verification
   * @param {string} newPassword - New password
   * @returns {Promise<object>} Response with success status
   */
  resetPassword: async (email, token, newPassword) => {
    try {
      const response = await apiClient.post("/auth/reset-password", {
        email,
        token,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Reset password error:", error);

      // STUB: Return dummy success for testing
      return {
        success: false,
        message: "Password reset failed",
      };
    }
  },
};

export default authApi;
